// Ported from  bfintal / Counter-Up
// https://github.com/bfintal/Counter-Up/blob/master/jquery.counterup.js

import { escape as regexpEscape } from '../js-lib/regexp'

class CounterUp {

	constructor (el, options) {
		this.el = el
		this.settings = Object.assign({
			initialValue: 0,
			duration: 400,
			frameTime: 10,
			separator: ',',
			decimalSeparator: '.'
		}, options)

		const separatorRE = new RegExp(regexpEscape(this.settings.separator), 'g')
		const value = el.textContent
		const dspos = value.indexOf(this.settings.decimalSeparator)
		const num = parseFloat(value.replace(separatorRE, ''))

		this.timer = null

		if (isNaN(num)) {
			this.num = null
			return
		}

		// 元の値（文字列）
		this.value = value

		// 桁区切りを取り除いた値（数値）
		this.num = num

		// 桁区切りを使用するかどうか
		this.useSeparator = separatorRE.test(num)

		// 小数点以下の桁数
		this.decimalPlaces = (dspos < 0) ? 0 : value.slice(dspos + 1).length
	}

	start () {
		this.startTime = Date.now()
		this.redraw()
	}

	stop () {
		clearTimeout(this.timer)
		this.timer = null
	}

	redraw () { 
		const progress = Math.min(1, (Date.now() - this.startTime) / this.settings.duration)

		if (progress < 1) {
			this.el.textContent = this.textAt(progress)
			this.timer = setTimeout(() => this.redraw(), this.settings.frameTime)
		} else {
			this.el.textContent = this.value
		}
	}

	textAt (progress) {
		const { initialValue } = this.settings
		const num = initialValue + (this.num - initialValue) * progress
		let text = num.toFixed(this.decimalPlaces)
		if (this.useSeparator) {
			while (/\d{4}/.test(text)) {
				text = text.toString().replace(/(\d+)(\d{3})/, '$1' + this.settings.separator + '$2')
			}
		}
		return text
    }
}

export default CounterUp
